
import BreadcrumbView from "../../common/breadcrumb/breadcrumb.html";
import TasksReportsListView from "./tasks_reports-list.html";

angular.module("tasks_reports", [])

    .config(['$stateProvider' ,function ($stateProvider) {
        $stateProvider
            .state('tasks_reports', {
                url: "/tasks_reports",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
                data: { pageTitle: "Informes de Tareas" }
            })
            .state('tasks_reports.list', {
                url: "/list",
                controller: "TasksReportsCtrl",
                template: TasksReportsListView,
                data: { pageTitle: "Informes de Tareas" }
            })            
        ;
    }])
;